// CMS is source of truth - languages match CMS LANGUAGES array
export const CMS_LANGUAGES = [
  "en",
  "es",
  "fr",
  "ja",
  "ko",
  "ar",
  "de",
  "he",
  "hi",
  "it",
  "ru",
  "zh",
] as const;

export type Language = (typeof CMS_LANGUAGES)[number];

export const languages: { id: Language; label: string }[] = [
  { id: "en", label: "English" },
  { id: "es", label: "Spanish" },
  { id: "fr", label: "French" },
  { id: "ja", label: "Japanese" },
  { id: "ko", label: "Korean" },
  { id: "ar", label: "Arabic" },
  { id: "de", label: "German" },
  { id: "he", label: "Hebrew" },
  { id: "hi", label: "Hindi" },
  { id: "it", label: "Italian" },
  { id: "ru", label: "Russian" },
  { id: "zh", label: "Chinese" },
];

export const languageIcons: Record<Language, string> = {
  en: "🇺🇸",
  es: "🇪🇸",
  fr: "🇫🇷",
  ja: "🇯🇵",
  ko: "🇰🇷",
  ar: "🇸🇦",
  de: "🇩🇪",
  he: "🇮🇱",
  hi: "🇮🇳",
  it: "🇮🇹",
  ru: "🇷🇺",
  zh: "🇨🇳",
};

export type Sex = "male" | "female";

export const sexes: { id: Sex; label: string }[] = [
  { id: "male", label: "Male" },
  { id: "female", label: "Female" },
];

export const sexIcons: Record<Sex, string> = {
  male: "👨",
  female: "👩",
};

export type Address = {
  id: string;
  address1: string;
  address2?: string | null;
  city: string;
  state?: string | null;
  postalCode: string;
  country: string;
};

export type ErrorBoundaryProps = {
  error?: Error | null;
  retry?: () => void;
};

export type Document = {
  id: string;
  url: string;
  name: string;
  date?: string | null;
  type?: string | null;
  size?: string | null;
  notes?: string | null;
  createdAt?: Date | null;
};
